<template>
  <v-container fluid>
    <v-row v-show="this.id">
      <v-col cols="12" md="4">
        <v-card class="pa-2">
          <v-card-title>
            <h4>Information sur la séance plénière d’attribution du marché concerné</h4>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <b>Titre de la séance plénière d’attribution :</b>
            {{ this.$store.getters["Auth/get_selected_attribution"].SA.title }}
            <v-spacer></v-spacer>
            <b>Date/heure de la séance plénière d’attribution :</b>
            {{
      this.$store.getters["Auth/get_selected_attribution"].SA.sessionDate
      | moment("dddd, Do MMMM YYYY")
    }}
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <b>Intitulé de la commission d’ouverture :</b>
            {{ this.$store.getters["Auth/get_selected_attribution"].SO.firstCommission.title }}
            <v-spacer></v-spacer>
            <b>Intitulé de la commission d’évaluation :</b>
            {{ this.$store.getters["Auth/get_selected_attribution"].SE.com.title }}
            <v-spacer></v-spacer>
          </v-card-text>
        </v-card>
        <v-card class="mt-2" v-if="profile == 6 && !this.$store.getters['Auth/get_selected_attribution'].signature_state
      ">
          <v-card-title>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <h4 class="h4" v-bind="attrs" v-on="on">Signature du Procès-Verbal d’attribution</h4>
              </template>
              <span>Signature du Procès-Verbal d’attribution</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="undo" class="white--text ml-4 text-center align-center" icon
              style="width: 200px;">
              <v-icon>
                mdi-backup-restore
              </v-icon>
              <span class="align-middle">Reprendre la signature</span>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <VueSignaturePad class="mx-auto" style="border:1px solid red" height="120px" width="100%"
              :options="{ penColor: 'rgba(0,43,89)', minWidth: 0.2, maxWidth: 1.5 }" ref="signaturePad" />

            <div></div>
          </v-card-text>
          <v-card-actions>
            <v-btn small color="primary" @click="save" class="white--text" block>
              <v-icon class="mr-2" dark>mdi-draw</v-icon>VALIDER LA SIGNATURE
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mt-4" v-if="profile != 2">
          <v-card-title>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <h4 class="h6" v-bind="attrs" v-on="on">Liste/nombre/qualité des membres de la commission d’attribution
                </h4>
              </template>
              <span>Liste/nombre/qualité des membres de la commission d’attribution</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-chip class="primary">
              <!-- + this.$store.getters['Auth/get_selected_attribution'].users_commission_eval.length -->
              {{ this.$store.getters["Auth/get_selected_attribution"].users_commission_os.length }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-virtual-scroll :items="this.$store.getters['Auth/get_selected_attribution'].users_commission_os"
              :item-height="50" height="110">
              <template v-slot="{ item }">
                <v-list-item>
                  <v-list-item-avatar>
                    <!-- <v-icon large color="primary" v-show="JSON.parse(localStorage.getItem('userData')).id == item.id">mdi-account-circle</v-icon> -->
                    <v-icon medium>mdi-account-circle</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.user.firstname }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.user.lastname }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span>{{ item.type.description }}</span>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card-text>
          <v-card-text> </v-card-text>
        </v-card>
        <!-- CODE BY KANTE -->

        <div class="mt-4">
          <v-card v-if="profile == 3" class="mt-2">
            <v-card-title>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">
                    <h4>
                      Transmission de lettre aux soumissionnaires
                    </h4>
                  </span>
                </template>
                <h4>
                  Transmettre la lettre aux soumissionnaires
                </h4>
              </v-tooltip>
            </v-card-title>
            <v-card-text>

              <v-select :items="getFilteredLetterTypes()" v-model="letter.type" item-text="description"
                item-value="status" label="Selectionner le type de lettre à envoyer aux soumissionnaires">
              </v-select>

              <v-select label="Selectionner le(s) soumissionnaire(s) concerné(s)" item-text="createdBy.firstname"
                v-model="letter.users" :items="this.$store.getters['Auth/get_selected_session'].offerList"
                item-value="createdBy.id" multiple>

              </v-select>

              <v-file-input v-model="letter.file" placeholder="Charger le fichier" label="Joindre la lettre à envoyer"
                multiple prepend-icon="mdi-paperclip">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>

            </v-card-text>
            <v-card-actions>
              <v-btn small color="primary" @click="sendLetterToOp" class="white--text" block>
                <v-icon small class="mr-2" dark>mdi-cloud-upload</v-icon> ENVOYER LA LETTRE
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>

        <v-card class="mt-2"
          v-if="profile == 6 && this.$store.getters['Auth/get_selected_projet'] && this.$store.getters['Auth/get_selected_attribution'].pv && !this.$store.getters['Auth/get_selected_attribution'].pv.valid">
          <v-card-title id="v-step-0">
            <h4>Voir le projet de marché</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-list-item class="block text-truncate">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-truncate font-weight-bold">
                    Projet de marché : {{
      this.$store.getters["Auth/get_selected_projet"].fileName }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small icon @click="viewFile('fileLink')">
                    <v-icon color="grey lighten-1">mdi-eye</v-icon>
                  </v-btn>

                </v-list-item-action>
              </v-list-item>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mt-2"
          v-if="profile == 6 && this.$store.getters['Auth/get_selected_attribution'].pv && !this.$store.getters['Auth/get_selected_attribution'].pv.valid">
          <v-card-title id="v-step-0">
            <h4>Répondre à la demande d'approbation du pv d'attribution</h4>
          </v-card-title>
          <v-card-text>
            <!-- Menu déroulant pour le choix "Valider" ou "Non Valider" -->
            <v-select v-model="isValidChoice" :items="['Je valide le pv', 'Pv non Validé']"
              label="Choix de validation"></v-select>

            <!-- Champs qui s'affichent lorsque "Valider" est choisi -->
            <div v-if="isValidChoice === 'Je valide le pv'">
              <v-file-input v-model="pvValidation.file" multiple label="Joindre la lettre" truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>

            <!-- Champs qui s'affichent lorsque "Non Valider" est choisi -->
            <div v-if="isValidChoice === 'Pv non Validé'">
              <v-file-input v-model="pvValidation.file" multiple label="Joindre le fichier des observations"
                truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>
            <v-btn small color="primary" class="ma-2 white--text" block @click="submitResponse">
              <v-icon class="mr-2" dark>mdi-cloud-upload</v-icon>Envoyer
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- CODE BY KANTE -->

        <!-- <v-card class="mt-1" v-if="profile != 2">
            <v-card-text>
              <v-virtual-scroll
                :items="this.$store.getters['Auth/get_selected_attribution'].users_commission_eval"
                :item-height="50"
                height="110"
              >
                <template v-slot="{ item }">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon medium>mdi-account-circle</v-icon>
                    </v-list-item-avatar>
  
                    <v-list-item-content>
                      <v-list-item-title>{{ item.user.firstname }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.user.lastname }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span>Membre</span>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-card-text>
            <v-card-text>
            </v-card-text>
          </v-card> -->
      </v-col>
      <v-col cols="12" md="8" v-if="profile != 2">
        <v-card>
          <v-card-title>
            <h4>
              Rédaction du Procès-Verbal (PV) de la séance plénière d’attribution du marché
              <!--{{ this.$store.getters["Auth/get_selected_attribution"].SA.sessionType.description }}-->
            </h4>
            <v-spacer></v-spacer>
            <span v-if="!profile == 5 || !profile == 6" v-show="!this.$store.getters['Auth/get_selected_attribution'].SA.generatedSign">
              <v-btn small v-show="this.$store.getters['Auth/get_selected_attribution'].pv"
                @click.prevent="GenerateSignature()" text depressed class="secondary">
                Generer la liste de presence
              </v-btn>
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="!this.$store.getters['Auth/get_selected_attribution'].pv">
            <DynamicAttribution :key="this.id" :attributionID="this.id"
              :sessionPV="this.$store.getters['Auth/get_selected_attribution'].pv_eval.file_blob"
              :sessionType="this.$store.getters['Auth/get_selected_attribution'].attribution_type" :readonly=true
              :readOnlyMode=true />
          </v-card-text>
          <v-card-text v-if="this.$store.getters['Auth/get_selected_attribution'].pv">
            <EditorViewer v-if="profile == 3" :isAllowedPrint="true" :key="this.id"
              :isPvObject="this.$store.getters['Auth/get_selected_attribution'].pv" />
            <EditorViewer v-if="profile != 3" :isAllowedPrint="false" :key="this.id"
              :isPvObject="this.$store.getters['Auth/get_selected_attribution'].pv" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" v-if="profile == 2">
        <v-card>
          <v-card-title>
            <h4>
              Le Procès-Verbal (PV) de la
              {{ this.$store.getters["Auth/get_selected_attribution"].SA.sessionType.description }}
            </h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="this.$store.getters['Auth/get_selected_attribution'].pv">
            <EditorViewer :isAllowedPrint="false" :key="this.id"
              :isPvObject="this.$store.getters['Auth/get_selected_attribution'].pv" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="dialog">
            <v-dialog eager v-model="dialog" width="900px">
                <v-card>
                    <v-card-title>
                        <h4>Aperçu du projet joint</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <VueDocPreview v-if="isDocumentType(fileLink)" :value="fileLink" type="office" />
                    <vue-friendly-iframe v-else-if="isPdfType(fileLink)" allow="true" :src="fileLink" class="w-62em"
                        frameborder="0" loading="lazy"></vue-friendly-iframe>
                </v-card>
            </v-dialog>
        </v-row>
  </v-container>
</template>
<script>
import VueDocPreview from "vue-doc-preview";
import DatePicker from "vue2-datepicker";
import DynamicAttribution from "../../../../config/DynamicAttribution";
import EditorViewer from "../../../../config/EditorViewer";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { EditorViewer, DynamicAttribution, DatePicker, VueDocPreview },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    userData: "",
    isValidChoice: null,
    fin: {
      start_time: null,
      selected: [],
    },
    allSign: [],
    GeneratedSignListCom: "",
    GeneratedSignListAuthCont: "",
    GeneratedSignListAuthReg: "",
    com: {
      file: [],
      com: 0,
    },
    docorNoticeID: 0,
    pv: [],
    ppm: [],
    additif: false,
    addi: {
      objet: "",
      publi_date: new Date(),
      file: [],
    },
    letter: {
      type: 0,
      file: [],
      users: [],
    },
    allUserstoDoc: [],
    attribution: {
      title: "",
      start_time: null,
      document: 0,
      user: [],
      commission: ""
    },
    pvValidation: {
      file: [],
    },
    dialog: false,
  }),
  computed: {
    ...mapGetters({
      get_eval_signature: "Auth/get_all_signature",
      get_sync_so: "Auth/get_sync_so"
    }),
  },
  created() {
    let Virt = [];
    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.userData = Virt;
    this.$store.dispatch("Auth/getAttribution", this.id);
    this.$store.dispatch("Auth/getSession", this.id);
    this.$store.dispatch("Auth/getOfferKeys", this.id);
    // Start By Kante
    this.$store.dispatch("Auth/getDoc", this.id);
    this.$store.dispatch("Auth/loadDocAdd", this.id);
    this.$store.dispatch("Auth/getSubmissionFoldNoti");
    this.$store.dispatch("Auth/getProjetMarcheBySession", this.id)
      .then(response => {
        console.log("LA REPONSE: ", response);
      });

    // End By Kante
  },
  methods: {
    ...mapActions({
      loadAllSignature: "Auth/loadAllSignature"
    }),
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    isDocumentType(fileLink) {
            const documentExtensions = ['doc', 'docx', 'xls', 'xlsx', 'XLS', 'XLSX'];
            const fileExtension = fileLink.split('.').pop();
            return documentExtensions.includes(fileExtension);
        },
        isPdfType(fileLink) {
            const pdfExtensions = ['pdf'];
            const fileExtension = fileLink.split('.').pop();
            return pdfExtensions.includes(fileExtension);
        },
    viewFile(file) {
      console.log("FILE", file);
      // Récupérer l'URL du fichier spécifique à partir du store
      const fileLink = this.$store.getters["Auth/get_selected_projet"][file];
      // Stocker l'URL du fichier dans une variable pour l'afficher dans la modale
      this.fileLink = fileLink;
      console.log("FILELINK", fileLink);
      // Afficher la modale pour visualiser le fichier
      this.dialog = true;
    },
    async UpdatePvSession(contentReceived, signature) {
      const data = new FormData();
      let content = contentReceived;
      content += signature;
      data.append("file_blob", content);
      data.append("attribution_id", this.id);
      await this.$store.dispatch("Auth/addPV", data);
      this.$router.go();
    },
    async GenerateSignature() {
      let signat = [];
      await this.loadAllSignature(this.id).then(() => {
        // eslint-disable-next-line prettier/prettier
        new Promise((r) => setTimeout(r, 2000));
        signat = this.$store.getters["Auth/get_all_signature"];
      });
      this.allSign = signat.data;
      // console.log(this.allSign);
      this.getThem();
    },
    async getThem() {
      let contener = "";
      const session = this.id;
      const collected_signature = this.allSign.filter(
        (value, index, arr) => value.openSession.id == session,
        session,
      );
      const AllCom = collected_signature.filter((value, index, arr) => value.com, session);

      let AuthCont = collected_signature.filter(function (value, index, arr) {
        return value.authCont;
      }, session);
      let AuthReg = collected_signature.filter(function (value, index, arr) {
        return value.authReg;
      }, session);

      AllCom.forEach((element, index, arr) => {
        this.GeneratedSignListCom += `<tr>
              <td>${index + 1}</td>
              <td>${element.name} ${element.surname}</td>
              <td>${element.fonction}</td>
              <td>${element.quality}</td>
              <td>
                <img width="277" src="${element.fileBlob}" alt="Signature ${element.id}" />
              </td>
            </tr>`;
      });

      AuthCont.forEach((element, index, arr) => {
        this.GeneratedSignListAuthCont += `<tr>
            <td>${index + 1}</td>
            <td>${element.name} ${element.surname}</td>
            <td>${element.fonction}</td>
            <td>${element.quality}</td>
            <td>
              <img width="277" src="${element.fileBlob}" alt="Signature ${element.id}" />
            </td>
          </tr>`;
      });

      AuthReg.forEach((element, index, arr) => {
        this.GeneratedSignListAuthReg += `<tr>
            <td>${index + 1}</td>
            <td>${element.name} ${element.surname}</td>
            <td>${element.fonction}</td>
            <td>${element.quality}</td>
            <td>
              <img width="277" src="${element.fileBlob}" alt="Signature ${element.id}" />
            </td>
          </tr>`;
      });

      const signatureCom = `<p>
        <strong>Annexe 1 : Liste de présence des membres de la comission</strong></p>
        <div class="tableWrapper">
              <table style="min-width: 50px;">
                <tbody>
                  <tr>
                    <th><p>N°</p></th>
                    <th><p>Nom et prénoms</p></th>
                    <th><p>Fonction/Structure</p></th>
                    <th><p> Qualité du membre de la commission</p></th>
                    <th><p>Signature</p></th>
                  </tr>
                  ${this.GeneratedSignListCom}
                </tbody>
              </table>
          </div>
          <p><br class="ProseMirror-trailingBreak"></p>`;

      let signatureAuthCont = `<p>
      <strong>Annexe 2 : Liste de présence des autorités de contrôle</strong></p>
      <div class="tableWrapper">
            <table style="min-width: 50px;">
              <tbody>
                <tr>
                  <th><p>N°</p></th>
                  <th><p>Nom et prénoms</p></th>
                  <th><p>Structure/Cabinet</p></th>
                  <th><p>Qualité du représentant</p></th>
                  <th><p>Signature</p></th>
                </tr>
                ${this.GeneratedSignListAuthCont}
              </tbody>
            </table>
        </div>
        <p><br class="ProseMirror-trailingBreak"></p>`;

      let signatureAuthReg = `<p>
      <strong>Annexe 2 : Liste de présence des autorités de régulation</strong></p>
      <div class="tableWrapper">
            <table style="min-width: 50px;">
              <tbody>
                <tr>
                  <th><p>N°</p></th>
                  <th><p>Nom et prénoms</p></th>
                  <th><p>Structure/Cabinet</p></th>
                  <th><p>Qualité du représentant</p></th>
                  <th><p>Signature</p></th>
                </tr>
                ${this.GeneratedSignListAuthReg}
              </tbody>
            </table>
        </div>
        <p><br class="ProseMirror-trailingBreak"></p>`;

      contener += signatureCom;
      contener += signatureAuthCont;
      contener += signatureAuthReg;

      this.UpdatePvSession(
        this.$store.getters["Auth/get_selected_attribution"].pv.file_blob,
        contener,
      );
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      const dataSign = new FormData();
      const userEmail = this.userData.email;
      const ChartTitle = this.$store.getters["Auth/get_selected_attribution"].list_auth;
      let UserTitle = ChartTitle.find(user => user.email === userEmail);
      // const UserTitle = ChartTitle.filter(
      //   (value, index, arr) => value.user.email == userEmail,
      //   userEmail,
      // );
      // console.log("HELLO", UserTitle);
      dataSign.append("file_blob", data);
      dataSign.append("attribution_id", this.id);
      // PROFILE SIGNING
      dataSign.append("is_rep", 0);
      dataSign.append("is_op", 0);
      dataSign.append("is_com", 0);
      dataSign.append("is_auth_reg", 0);
      dataSign.append("is_auth_cont", 1);
      // DATA TO SEND
      dataSign.append("name", this.userData.firstname);
      dataSign.append("surname", this.userData.lastname);
      dataSign.append("email", this.userData.email);
      dataSign.append("fonction", this.userData.profession);
      dataSign.append("quality", UserTitle.profile.description);

      if (!isEmpty) {
        // console.log(UserTitle[0].type.description);
        this.$store.dispatch("Auth/addAttrSignature", dataSign);
      } else {
        // alert swal sign empty
      }
    },
    financialProp() {
      const data = new FormData();
      data.append("document", this.com.com);
      data.append("selected_offer", this.fin.selected);
      data.append("start_time", this.fin.start_time);
      data.append("duration", 160);
      data.append("password", 1234);
      this.$store.dispatch("Auth/comCall", data);
    },

    // sendLetterToOp() {

    //   const data = new FormData();
    //   const selectedUsers = this.attribution.user;
    //   // data.append("doc_id", this.id);
    //   data.append("letter_type_id", this.letter.type);
    //   // if (this.addi.file) {
    //   data.append("file", this.letter.file[0]);
    //   // } else {
    //   // data.append("file", null);
    //   // }
    //   selectedUsers.forEach(user => {
    //          data.append("selected_users[]", user.id);
    //          console.log("L'utilisateur est:" + user.id)
    //   });

    //   this.$store.dispatch("Auth/sendLetter", data);
    // },

    getFilteredLetterTypes() {
      // par votre propre accès aux données depuis le store Vuex
      const letterTypes = this.$store.getters["Auth/get_all_legal_form"].letter_type;

      // Filtrer les letter_type ayant les status 3 et 4
      return letterTypes.filter((letterType) => letterType.status === 3 || letterType.status === 4);
    },

    async sendLetterToOp() {
      try {
        const letterType = this.letter.type;
        const selectedUsers = this.letter.users;
        const selectedFile = this.letter.file[0];

        // console.log("TYPE DE LETTRE ====>" + letterType);
        //console.log("LISTE DES IDs DES UTILISATEURS ====>" + selectedUsers);
        // console.log("FICHIER SELECTIONNE ====>" + selectedFile.name);

        if (!letterType || !selectedUsers || !selectedFile) {
          console.error(
            "Veuillez sélectionner le type de lettre, les soumissionnaires concernés et joindre un fichier."
          );
          return;
        }
        const formattedUsers = selectedUsers.join('-');
        // console.log("Les users" + formattedUsers)
        const data = new FormData();
        // data.append("doc_id", 5);
        data.append("letter_type_id", letterType);
        data.append("users", formattedUsers);
        data.append("letter_file", selectedFile);

        // selectedUsers.forEach(user => {
        //   data.append("users", user.id);
        //   console.log("L'utilisateur est:" + user.id);
        // });

        const response = await this.$store.dispatch("Auth/sendLetter", data);

        if (response) {
          if (response.data) {
            console.log("Succès !! Lettre envoyée avec succès !");
            this.$toast.success(response.message); // Utilisez la librairie de notifications/toasts de votre choix
          } else {
            console.error("L'envoi de la lettre a échoué :", response.message);
            this.$toast.error(response.message);
          }
        } else {
          console.error("Réponse indéfinie.");
        }
      } catch (error) {
        console.error("Une erreur s'est produite lors de l'envoi de la lettre :", error);
      }
    },

    async submitResponse() {
      this.isLoading = true;
      try {
        if (this.isValidChoice === 'Je valide le pv') {
          // Call the validatePPM API here
          console.log(this.id);
          const formData = new FormData();
          formData.append('session', this.id);
          formData.append('status', true);
          formData.append('file_letter', this.pvValidation.file[0]);
          const response = await this.$store.dispatch("Auth/validatePvAttribution", formData);
          this.isValidChoice = "";
          this.pvValidation.file = null;
          console.log(response);
        } else if (this.isValidChoice === 'Pv non Validé') {
          // Call the addPpmObservation API here
          const formData = new FormData();
          formData.append('session', this.id);
          formData.append('status', false);
          formData.append('file_letter', this.pvValidation.file[0]);
          const response = await this.$store.dispatch("Auth/validatePvAttribution", formData);
          this.isValidChoice = "";
          this.pvValidation.file = null;
          console.log(response);
        }
      } catch (error) {
        console.error(error); // Handle errors
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style>
.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}

.vue-daterange-picker {
  width: 100%;
}

.mx-datepicker {
  width: 100%;
}

h4 {
  word-break: break-word;
}
</style>